<template>
  <div v-if="isShow" class="charge-overlay" @click.self="$emit('close')">
    <div class="charge-modal">
      <div class="charge-modal-header">
        <h3>적립금 충전</h3>
        <button class="charge-close-btn" @click="$emit('close')">✕</button>
      </div>
      <div class="charge-modal-body">
        <div class="charge-info-box">
          <p>충전금액과 계좌를 문자로 보내드립니다.</p>
          <p>해당 계좌로 입금해 주시면 됩니다.</p>
          <div class="charge-bonus-info">
            <p>· 50만원 이상 입금시 1%, 100만원 이상 입금시 2%, 300만원 이상 3%</p>
            <p>&nbsp;&nbsp;추가 코끼리 포인트가 적립됩니다.</p>
          </div>
        </div>
        <div class="charge-form-row">
          <label class="charge-label">충전금액</label>
          <div class="charge-amount-btns">
            <button
              v-for="unit in amountUnits"
              :key="unit"
              type="button"
              class="charge-amount-btn"
              @click="fn_addAmount(unit)"
            >{{ unit / 10000 }}만원</button>
          </div>
        </div>
        <div class="charge-form-row">
          <label class="charge-label">충전액</label>
          <div class="charge-input-wrap">
            <input
              type="text"
              class="charge-input"
              :value="chargeInfo.amount ? chargeInfo.amount + ' 원' : ''"
              placeholder="충전금액 버튼을 눌러주세요"
              readonly
            />
            <button
              v-if="chargeInfo.amount"
              type="button"
              class="charge-clear-btn"
              title="삭제"
              @click="fn_clearAmount"
            >✕</button>
          </div>
        </div>
        <div class="charge-form-row">
          <label class="charge-label">핸드폰번호</label>
          <input
            type="text"
            class="charge-input"
            v-model="chargeInfo.phone"
            placeholder="핸드폰번호를 입력하세요"
            maxlength="13"
            @input="fn_onPhoneInput"
          />
        </div>
      </div>
      <div class="charge-modal-footer">
        <button class="btn btn_md btn_darkbrown" @click="fn_chargeRequest">요청</button>
        <button class="btn btn_md btn_gray" @click="$emit('close')">닫기</button>
      </div>
    </div>
  </div>
</template>

<script>
import { loadTossPayments } from '@tosspayments/payment-sdk'

//const TOSS_CLIENT_KEY = 'test_ck_6bJXmgo28eAewEwXMdyW8LAnGKWx'    // localtest
const TOSS_CLIENT_KEY = 'live_ck_jExPeJWYVQwJ2ZLopQNx849R5gvN'  // 라이브

export default {
  name: 'depositRequestModal',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    clinicDoctorId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chargeInfo: {
        amount: '',
        phone: '',
      },
      amountUnits: [500000, 1000000, 2000000, 3000000],
    }
  },
  watch: {
    isShow(val) {
      if (val) {
        const phone = this.fn_formatPhone(this.$store.getters['clinicDoctorInfo/getDoctorPhoneNum'] || '')
        this.chargeInfo = { amount: '', phone }
      }
    },
  },
  methods: {
    fn_formatPhone(value) {
      const val = String(value).replace(/[^0-9]/g, '')
      if (val.length <= 7) {
        return val.replace(/(\d{3})(\d{1,4})/, '$1-$2')
      }
      return val.replace(/(\d{3})(\d{4})(\d{1,4})/, '$1-$2-$3')
    },
    fn_addAmount(unit) {
      const total = Number(this.chargeInfo.amount.replace(/,/g, '')) + unit
      this.chargeInfo.amount = total.toLocaleString()
    },
    fn_clearAmount() {
      this.chargeInfo.amount = ''
    },
    fn_onPhoneInput(e) {
      this.chargeInfo.phone = this.fn_formatPhone(e.target.value)
    },
    async fn_chargeRequest() {
      const amount = Number(this.chargeInfo.amount.replace(/,/g, ''))
      if (!amount) {
        this.$emit('showAlert', '충전금액을 선택해 주세요.')
        return
      }
      if (!this.chargeInfo.phone) {
        this.$emit('showAlert', '핸드폰번호를 입력해 주세요.')
        return
      }

      try {
        const tossPayments = await loadTossPayments(TOSS_CLIENT_KEY)
        //Toss 주문번호 생성
        const orderId = `DEP-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2, 6).toUpperCase()}`

        sessionStorage.setItem('toss_pending_payment', JSON.stringify({
          paymentType: 'DR',
          orderId,
          amount,
          phone: this.chargeInfo.phone,
          clinic_doctor_id: this.clinicDoctorId,
          paymentMethod : 'VB',
        }))

        await tossPayments.requestPayment('가상계좌', {
          amount,
          orderId,
          orderName: '적립금 충전',
          customerName: this.$store.getters['clinicDoctorInfo/getDoctorNm'],
          customerMobilePhone: this.chargeInfo.phone.replace(/-/g, ''),
          validHours: 24,
          successUrl: `${window.location.origin}/payment/toss/success`,
          failUrl: `${window.location.origin}/payment/toss/fail`,
        })
      } catch (err) {
        if (err.code === 'USER_CANCEL') return
        this.$emit('showAlert', '결제 중 오류가 발생했습니다.')
        console.error(err)
      }
    },
  },
}
</script>

<style scoped>
.charge-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.charge-modal {
  background: #fff;
  border-radius: 12px;
  width: 480px;
  max-width: 95vw;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}
.charge-modal-header {
  background: #5a3e28;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.charge-modal-header h3 {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}
.charge-close-btn {
  background: none;
  border: none;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  opacity: 0.8;
  line-height: 1;
  padding: 0;
}
.charge-close-btn:hover {
  opacity: 1;
}
.charge-modal-body {
  padding: 24px;
}
.charge-info-box {
  background: #fdf3e3;
  border: 1px solid #e0c89a;
  border-radius: 8px;
  padding: 16px 18px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #5a3e28;
  line-height: 1.7;
}
.charge-bonus-info {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #e0c89a;
  color: #c0392b;
  font-size: 13px;
}
.charge-form-row {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.charge-label {
  width: 90px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  flex-shrink: 0;
}
.charge-input {
  flex: 1;
  height: 38px;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 0 12px;
  font-size: 14px;
  outline: none;
}
.charge-input:focus {
  border-color: #8b6b3d;
}
.charge-input[readonly] {
  background: #f7f7f7;
  font-weight: 600;
  color: #1a5fa8;
  padding-right: 36px;
}
.charge-input-wrap {
  flex: 1;
  position: relative;
  display: flex;
}
.charge-clear-btn {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 50%;
  background: #bbb;
  color: #fff;
  font-size: 12px;
  line-height: 22px;
  padding: 0;
  cursor: pointer;
}
.charge-clear-btn:hover {
  background: #888;
}
.charge-amount-btns {
  flex: 1;
  display: flex;
  gap: 6px;
}
.charge-amount-btn {
  flex: 1;
  height: 38px;
  border: 1px solid #8b6b3d;
  border-radius: 6px;
  background: #fff;
  color: #5a3e28;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.charge-amount-btn:hover {
  background: #fdf3e3;
}
.charge-modal-footer {
  display: flex;
  gap: 8px;
  justify-content: center;
  padding: 16px 24px;
  border-top: 1px solid #eee;
}
</style>